import "./loader.css"

export function Loader()
{
    return <div className="loader"></div>
}